import { render, staticRenderFns } from "./ProjectViewButton.vue?vue&type=template&id=6fbdb1e5&scoped=true&"
import script from "./ProjectViewButton.vue?vue&type=script&lang=js&"
export * from "./ProjectViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewButton.vue?vue&type=style&index=0&id=6fbdb1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbdb1e5",
  null
  
)

export default component.exports